import React, { useEffect } from 'react';
import { UserContextProvider } from 'Context/UserContext';
import { IdentityChallengeProvider } from 'Context/IdentityChallengeContext';
import { IterateSurveyProvider } from 'Integrations/IterateSurveyProvider';
import ContentRouter from 'ContentRouter';
import { SwaggerlessProvider } from 'Context/SwaggerlessContext';
import { teardownSegment } from 'EventTracking/Vendors/Segment';
import { teardownGoogleAnalytics } from 'EventTracking/Vendors/GoogleAnalytics';

const NotBuyPage = () => {
  useEffect(() => {
    // If somehow google analytics has been enabled on this page it must be torn down
    // We don't expect this should be true, but this is a stopgap just in case it
    // was erroneously initialized
    teardownGoogleAnalytics();
    teardownSegment();
  }, []);

  return (
    <SwaggerlessProvider>
      <UserContextProvider>
        <IdentityChallengeProvider>
          <IterateSurveyProvider>
            <ContentRouter />
          </IterateSurveyProvider>
        </IdentityChallengeProvider>
      </UserContextProvider>
    </SwaggerlessProvider>
  );
};

export default NotBuyPage;
